"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledCurrencyInput = void 0;
var _ykbStyledComponents = _interopRequireDefault(require("../ykb-styled-components"));
var _TextInput = require("../TextInput");
var StyledCurrencyInput = exports.StyledCurrencyInput = (0, _ykbStyledComponents.default)(_TextInput.TextInput).withConfig({
  componentId: "ykb-ui__sc-1unxda8-0"
})(["text-align:", ";"], function (props) {
  return props.valuePosition == 'center' ? 'center' : props.valuePosition == 'left' ? 'left' : 'right';
});